
/* ===================== LISTAS EDITABLES ===================== */
/* Pega aquí los SKUs (ej. 'V601') o nombres de cada lista.      */
window.VELANTIS_NOVEDADES = [];          /* Novedades 2026        */
window.VELANTIS_PREVENTA  = [
  {name:'LA BOMBA INTENSA', brand:'Carolina Herrera', gender:'Dama', img:'florales'},
  {name:'BOSS ALIVE SPARKLING LAVENDER', brand:'Hugo Boss', gender:'Dama', img:'florales'},
  {name:'TOY 2 GUMMY', brand:'Moschino', gender:'Dama', img:'dulces'},
  {name:'L12.12 SILVER ROSE', brand:'Lacoste', gender:'Dama', img:'florales'},
  {name:'ACQUA DI GIO INTENSE', brand:'Giorgio Armani', gender:'Caballero', img:'citricas'},
  {name:'SCANDAL POUR HOMME ELIXIR', brand:'Jean Paul Gaultier', gender:'Caballero', img:'amaderados'},
  {name:'BOSS BOTTLED STRIKING LAVENDER', brand:'Hugo Boss', gender:'Caballero', img:'amaderados'},
  {name:'L12.12 SILVER GREY', brand:'Lacoste', gender:'Caballero', img:'amaderados'},
  {name:'TAORMINA ORANGE EDP', brand:'Tom Ford', gender:'Unisex', img:'citricas'},
  {name:'CHASING SUNSETS', brand:'Maison Margiela', gender:'Unisex', img:'ambar'}
];          /* Preventa */
window.VELANTIS_PREVENTA_FECHA = '';     /* opcional: '2026-09-15'*/
/* =========================================================== */
